import { PUBLIC_URL } from '../server-parameters'


export async function getCommonContent():Promise<Services_Common_Dto_DT_Public_PublicOrganizationDto> {
  const headers = new Headers({
    'content-type': 'application/json',
    accept: 'text/plain',
  })
  if (!headers.has('authorization')) {
    const token = window.localStorage.ORDER_ID
    headers.set('Authorization', 'Bearer ' + token)
  }

  const fullUrl = PUBLIC_URL + '/PublicContent/commonContent'
  const fetchOptions = {
    headers,
    method: 'Get',
  }
  let response = await fetch(fullUrl, fetchOptions)

  return response.json()
}

export type Services_Common_Dto_DT_Public_PublicOrganizationDto = {
  organizationName?: string | null;
  phoneNumberPrimary?: string | null;
  phoneNumberSecondary?: string | null;
  email?: string | null;
  addressShort?: string | null;
  postalCode?: string | null;
  addressLong?: string | null;
  exceptedDate?: string | null;
  howToFindUs?: string | null;
  paymentMethodsTitle?: string | null;
  city?: string | null;
  mapUrl?: string | null;
  socialLinks?: {
    type: Services_Common_Enums_SocialLinkType;
    link: string;
  }[] | null;
  paymentServices?: any;
  schedules?: any;
  seo?: any;
  schedule?: string | null;
};

export enum Services_Common_Enums_SocialLinkType {
  Other = 0,
  Vk = 1,
  Facebook = 2,
  Youtube = 3,
  Vimeo = 4,
  Instagram = 5,
  WorkWebsite = 6,
  PersonalWebsite = 7,
  AdditionalLinks = 8,
  Telegram = 9,
  Whatsapp = 10,
  Viber = 11,
  Odnoklassniki = 12,
  Twitter = 13,
  Skype = 14,
}